import React, { memo, forwardRef, useMemo } from 'react';
import cn from 'classnames';
import { getScrollbarWidth } from '../../utils';
import styles from './styles.module.css';
export const HiddenScroll = memo(forwardRef(function HiddenScroll({ children, className, type = 'vertical', style, ...rest }, ref) {
    const finalStyle = useMemo(() => {
        const scrollBarWidth = getScrollbarWidth();
        return {
            ...style,
            ['--scrollbar-width']: `${scrollBarWidth}px`,
        };
    }, [style]);
    return (React.createElement("div", { ref: ref, className: cn(className, styles.outer, {
            [styles.vertical]: type === 'vertical',
            [styles.horizontal]: type === 'horizontal',
        }), style: finalStyle, ...rest }, children({
        className: cn(styles.inner, {
            [styles.vertical]: type === 'vertical',
            [styles.horizontal]: type === 'horizontal',
        }),
    })));
}));
